<!-- Sale Details -->
<div class="w-full bg-fff6f3 rounded-lg p-2">
  <!-- title and total amount -->
  <div (click)="toggleAccordion('sale')"
    class="cursor-pointer pb-2 border-b border-8f1201 flex items-center justify-between gap-2">
    <div class="flex items-center justify-start gap-4">
      <p class="text-sm sm:text-base xl:text-lg font-semibold text-8f1201">{{ saleSummary.title }}</p>
      <p class="w-5 h-5 bg-[#fff] rounded-full flex items-center justify-center">
        <svg [class.rotate-180]="accordionState.sale" class="transition-transform duration-300" viewBox="0 0 20 20"
          fill="none" xmlns="http://www.w3.org/2000/svg"
          class="fill-8a8a8a group-hover:fill-0d5bab size-5 transition-transform duration-300">
          <path d="M5.83398 8.3335L10.0007 12.5002L14.1673 8.3335H5.83398Z"></path>
        </svg>
      </p>
    </div>
    <div class="flex items-center gap-4">
      <p *ngIf="loading" class="text-sm text-gray-500 animate-pulse">Loading...</p>
      <p class="text-sm sm:text-base lg:text-lg font-semibold text-8f1201">₹ {{ saleSummary.total | number:'1.2-2' }}
      </p>
    </div>
  </div>
  <!-- scrollable area -->
  <div class="overflow-x-auto w-full text-sm lg:text-base flex items-center gap-3 mt-2">
    <div *ngFor="let chip of chips" class="bg-[#fff] px-2 py-1.5 rounded-md w-max shadow-sm border border-gray-100">
      <p class="flex items-center gap-2 w-max text-777 font-medium">
        <span class="text-686868">{{ chip.label }}</span>|
        <span class="text-1c1c1c font-semibold">{{ chip.value }}</span>
      </p>
    </div>
  </div>
  <!-- Amount Table -->
  <div class="transition-all duration-300 ease-in-out overflow-hidden" [class.max-h-0]="!accordionState.sale"
    [class.max-h-[2000px]]="accordionState.sale">
    <div class="mt-2 overflow-x-auto w-full">
      <table class="daybook-table w-full overflow-hidden text-center">
        <thead class="text-xs sm:text-sm uppercase font-semibold">
          <tr class="bg-ffe3b1">
            <th class="p-2">Inv No</th>
            <th class="p-2">Date</th>
            <th class="p-2">Customer</th>
            <th class="p-2">Total Amt</th>
            <th class="p-2">Recd Amt</th>
            <th class="p-2">Due Amt</th>
            <th class="p-2">Metal Billed</th>
            <th class="p-2">Metal Recd</th>
            <th class="p-2">Metal Settled</th>
            <th class="p-2">Metal Due</th>
          </tr>
        </thead>
        <tbody class="text-xs sm:text-sm font-medium">
          <tr *ngFor="let sale of sales" class="border-b border-gray-100 hover:bg-[#fff]/50">
            <td class="p-2">{{ sale.invoice_number }}</td>
            <td class="p-2 whitespace-nowrap">{{ sale.invoice_date | date:'dd MMM yyyy' }}</td>
            <td class="p-2 text-left">
              <p class="font-semibold">{{ sale.customer_name }}</p>
              <p class="text-[10px] text-gray-500">{{ sale.customer_mob }}</p>
            </td>
            <td class="p-2 font-semibold">₹{{ sale.total_amount | number:'1.2-2' }}</td>
            <td class="p-2 text-018f37">₹{{ sale.amount_paid | number:'1.2-2' }}</td>
            <td class="p-2 text-bb0000">₹{{ sale.balance_due | number:'1.2-2' }}</td>
            <td class="p-2">{{ sale.total_metal_billed | number:'1.2-2' }}gm</td>
            <td class="p-2 text-018f37">{{ sale.metal_received | number:'1.2-2' }}gm</td>
            <td class="p-2 text-metal-settled-blue">{{ sale.metal_settled | number:'1.2-2' }}gm</td>
            <td class="p-2 text-bb0000">{{ sale.metal_due | number:'1.2-2' }}gm</td>
          </tr>
          <tr *ngIf="sales.length === 0 && !loading">
            <td colspan="10" class="p-8 text-center text-gray-500">No sales records found for the selected period.</td>
          </tr>
        </tbody>
        <tfoot class="bg-ffe3b1 text-xs sm:text-sm font-bold">
          <tr>
            <td colspan="3" class="p-2 text-right uppercase">Total:</td>
            <td class="p-2">₹{{ saleSummary.total | number:'1.2-2' }}</td>
            <td class="p-2 text-018f37">₹{{ saleSummary.amount_received | number:'1.2-2' }}</td>
            <td class="p-2 text-bb0000">₹{{ saleSummary.balance_due | number:'1.2-2' }}</td>
            <td class="p-2">{{ saleSummary.metal_billed | number:'1.2-2' }}gm</td>
            <td class="p-2 text-018f37">{{ saleSummary.metal_received | number:'1.2-2' }}gm</td>
            <td class="p-2 text-metal-settled-blue">{{ saleSummary.metal_settled | number:'1.2-2' }}gm</td>
            <td class="p-2 text-bb0000">{{ saleSummary.metal_due | number:'1.2-2' }}gm</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>